import LocalPrintshopIcon from '@material-ui/icons/LocalPrintshop';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { LoadingButton } from '@mui/lab';
import {
  Accordion,
  AccordionSummary,
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  Typography
} from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useMonitoringVisitLog } from 'src/components/StartUp/studyLogs/MonitoringVisitLogs/useMonitoringVisitLog';
import Loader from 'src/components/common/Loader';
import { PopupComponent } from 'src/components/common/PopupComponent';
import printPdfWithViewer from 'src/components/common/PrintPdfWithViewer';
import ProgressBar from 'src/components/common/ProgressBar';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import { UI_TIME_ZONE } from 'src/constants/formats';
import { useLazyGetimvReportDataQuery } from 'src/services/IMVReport';
import { hideLoader, showLoader } from 'src/store/Loader';
import { setMessage } from 'src/store/Message';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { IIMVChecklistDetails } from 'src/types/IMVCheklist';
import { QulificationFileData } from 'src/types/SQReport';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import BiologicalSampling from './BiologicalSampling';
import Discussion from './Discussion';
import ECIRB from './ECIRB';
import IMVReportSendForReview from './IMVReportSendForReview';
import InfomredConsentProcess from './InfomredConsentProces';
import InvestigationalMedicine from './InvestigationalMedicine';
import Lab from './Lab';
import MonitioringRequirments from './MonitioringRequirments';
import PersonnelPresent from './PersonnelPresent';
import ProtocolDeviations from './ProtocolDeviations';
import RecruitmentStatus from './RecruitmentStatus';
import SeriousAdverseEvents from './SeriousAdverseEvents';
import Signatures from './Signatures';
import Site from './Site';
import Supplies from './Supplies';
import { useIMVReportPage } from './UseIMVReportPage';
import { setShowIMVReportCMPArr } from 'src/store/imvReport';
import { archLevel } from 'src/data/config';

const IMVReportPage: React.FunctionComponent<any> = () => {
  const [expanded, setExpanded] = React.useState(true);
  const [expanded0, setExpanded0] = React.useState(false);
  const [expanded1, setExpanded1] = React.useState(false);
  const [expanded2, setExpanded2] = React.useState(false);
  const [expanded3, setExpanded3] = React.useState(false);
  const [expanded4, setExpanded4] = React.useState(false);
  const [expanded5, setExpanded5] = React.useState(false);
  const [expanded6, setExpanded6] = React.useState(false);
  const [expanded7, setExpanded7] = React.useState(false);
  const [expanded8, setExpanded8] = React.useState(false);
  const [expanded9, setExpanded9] = React.useState(false);
  const [expanded10, setExpanded10] = React.useState(false);
  const [expanded11, setExpanded11] = React.useState(false);
  const [expanded12, setExpanded12] = React.useState(false);
  const isLoading = false;
  const [isDataUpdate, setIsDataUpdate] = useState(false);
  const { checkPermission } = usePermissionWrapper();
  const [isUpdate, setIsupdate] = useState(false);
  const dispatch = useDispatch();
  const dispatchApp = useAppDispatch();
  const [imvChecklistPageData, setImvChecklistPageData] = useState<Partial<IIMVChecklistDetails>>({});
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const selectedRowData: any = useAppSelector(state => state.imvReport.selectedRowData);
  const { user } = useUser();
  const { userPreferedDateFormat, getPreferredDateTimeInLocal } = usePreferedDateFormat();
  const isDisable = checkPermission('update_imvreport');
  const [isPrintEnable, setIsprintEnable] = useState(false);
  const [isSaveEnable, setIsSaveEnable] = useState(false);
  const { selectedAppSection } = useSelectedAppInfo();
  const [checkedInStartDate, setCheckedInStartDate] = useState<any>(null);
  const disable = selectedRowData.actual_start_date === null;

  const {
    updateSignDataFn,
    updateSignIsLoading,
    updateSignSuccess,
    updateSignIsError,
    updateSignError,
    updateImvReportIsLoading,
    updateImvReportSuccess,
    updateImvReportDataFn,
    updateImvReportIsError,
    updateImvReportError,
    createImvReportLoading,
    createImvReportSuccess,
    createImvReportDataFn,
    createImvReportIsError,
    createImvReportError,
    publishImvReportDataFn,
    publishImvReportSuccess,
    publishImvReportError,
    sendForReviewFunc
  } = useIMVReportPage();
  const { getAllMonitoringVisits } = useMonitoringVisitLog();

  const [fileObjects, setFileObjects] = useState<QulificationFileData[]>([]);
  const [fileObjects2, setFileObjects2] = useState<QulificationFileData[]>([]);
  const [fileObjects3, setFileObjects3] = useState<QulificationFileData[]>([]);
  const [fileObjects4, setFileObjects4] = useState<QulificationFileData[]>([]);
  const [fileObjects5, setFileObjects5] = useState<QulificationFileData[]>([]);
  const [fileObjects6, setFileObjects6] = useState<QulificationFileData[]>([]);

  const [personnelPresent, setPersonnelPresent] = useState([
    {
      stdy_imvrp_personnel_name: null,
      stdy_imvrp_personnel_role: null,
      stdy_imvrp_personnel_affiliation: null
    }
  ]);

  const [recruitmentStatus, setRecruitmentStatus] = useState({
    stdy_imvrp_sub_screen: null,
    stdy_imvrp_sub_enrolled: null,
    stdy_imvrp_sub_sf: null,
    stdy_imvrp_sub_treat: null,
    stdy_imvrp_sub_fup: null,
    stdy_imvrp_sub_compl: null,
    stdy_imvrp_sub_lfup: null,
    stdy_imvrp_sub_withdraw: null
  });

  const [section1, setSection1] = useState({
    stdy_imvrp_recruit: null,
    stdy_imvrp_recruit_com: null,
    stdy_imvrp_rplan_rev: null,
    stdy_imvrp_rplan_rev_comm: null,
    stdy_imvrp_rplan_actions: null,
    stdy_imvrp_rplan_action_comm: null,
    stdy_imvrp_retention: null,
    stdy_imvrp_retention_comm: null,
    stdy_imvrp_ret_actions: null,
    stdy_imvrp_ret_action_comm: null,
    stdy_imvrp_new_pers: null,
    stdy_imvrp_new_pers_comm: null,
    stdy_imvrp_training_todate: null,
    stdy_imvrp_training_comment: null,
    stdy_imvrp_doa_completeness: null,
    stdy_imvrp_doa_completeness_comment: null,
    stdy_imvrp_sa_ss_st_attachment1: null
  });

  const [section2, setSection2] = useState({
    stdy_imvrp_irb_sub: null,
    stdy_imvrp_irb_sub_comm: null,
    stdy_imvrp_irb_approval: null,
    stdy_imvrp_irb_approval_comm: null,
    stdy_imvrp_irb_pending: null,
    stdy_imvrp_irb_pending_comm: null
  });

  const [section3, setSection3] = useState({
    stdy_imvrp_new_consent: null,
    stdy_imvrp_new_consent_comm: null,
    stdy_imvrp_cons_regulation: null,
    stdy_imvrp_cons_regulation_comm: null,
    stdy_imvrp_cons_doc: null,
    stdy_imvrp_cons_doc_comm: null,
    stdy_imvrp_cons_attach2: null
  });

  const [section4, setSection4] = useState({
    stdy_imvrp_source_doc: null,
    stdy_imvrp_source_doc_comm: null,
    stdy_imvrp_source_rev: null,
    stdy_imvrp_source_rev_comm: null,
    stdy_imvrp_sdv: null,
    stdy_imvrp_sdv_comm: null,
    stdy_imvrp_end_pt: null,
    stdy_imvrp_end_pt_comm: null,
    stdy_imvrp_data_int: null,
    stdy_imvrp_data_int_comm: null,
    stdy_imvrp_action_log: null,
    stdy_imvrp_action_log_comm: null,
    stdy_imvrp_pro_qna: null,
    stdy_imvrp_pro_qna_comm: null,
    stdy_imvrp_mon_attachments: null
  });

  const [section5, setSection5] = useState({
    stdy_imvrp_sae_fup: null,
    stdy_imvrp_sae_fup_comm: null,
    stdy_imvrp_sae_report: null,
    stdy_imvrp_sae_report_comm: null,
    stdy_imvrp_sae_sponsor: null,
    stdy_imvrp_sae_sponsor_comm: null,
    stdy_imvrp_sae_irb: null,
    stdy_imvrp_sae_irb_comm: null,
    stdy_imvrp_event_fup: null,
    stdy_imvrp_event_fup_comm: null,
    stdy_imvrp_sreport_irb: null,
    stdy_imvrp_sreport_irb_comm: null,
    stdy_imvrp_sreport_review: null,
    stdy_imvrp_sreport_review_comm: null
  });

  const [section6, setSection6] = useState({
    stdy_imvrp_csp_procedures: null,
    stdy_imvrp_csp_procedure_comm: null,
    stdy_imvrp_csp_pd: null,
    stdy_imvrp_csp_pd_comm: null,
    stdy_imvrp_csp_inelig: null,
    stdy_imvrp_csp_inelig_comm: null,
    stdy_imvrp_csp_attachments: null
  });

  const [section7, setSection7] = useState({
    stdy_imvrp_ip_acc: null,
    stdy_imvrp_ip_acc_comm: null,
    stdy_imvrp_ip_req: null,
    stdy_imvrp_ip_req_comm: null,
    stdy_imvrp_ip_excur: null,
    stdy_imvrp_ip_excur_comm: null,
    stdy_imvrp_ip_issues: null,
    stdy_imvrp_ip_issues_comm: null,
    stdy_imvrp_ip_ship_rec: null,
    stdy_imvrp_ip_ship_rec_comm: null,
    stdy_imvrp_ip_suff: null,
    stdy_imvrp_ip_suff_comm: null,
    stdy_imvrp_ip_unblind: null,
    stdy_imvrp_ip_unblind_comm: null,
    stdy_imvrp_ip_attachments: null
  });

  const [section8, setSection8] = useState({
    stdy_imvrp_supply: null,
    stdy_imvrp_supply_comm: null
  });

  const [section9, setSection9] = useState({
    stdy_imvrp_bio_collect: null,
    stdy_imvrp_bio_collect_comm: null,
    stdy_imvrp_bio_handling: null,
    stdy_imvrp_bio_handling_comm: null
  });

  const [section10, setSection10] = useState({
    stdy_imvrp_llab_cert: null,
    stdy_imvrp_llab_cert_comm: null,
    stdy_imvrp_calibrate: null,
    stdy_imvrp_calibrate_comm: null,
    stdy_imvrp_llab_range: null,
    stdy_imvrp_llab_range_comm: null
  });

  const [section11, setSection11] = useState({
    stdy_imvrp_pid_enrol: null,
    stdy_imvrp_pid_enrol_comm: null,
    stdy_imvrp_pid_study_up: null,
    stdy_imvrp_pid_study_up_comm: null,
    stdy_imvrp_pid_staff: null,
    stdy_imvrp_pid_staff_comm: null,
    stdy_imvrp_pid_oversight: null,
    stdy_imvrp_pid_oversight_comm: null,
    stdy_imvrp_pid_issues: null,
    stdy_imvrp_pid_issues_comm: null,
    stdy_imvrp_pid_sproc: null,
    stdy_imvrp_pid_sproc_comm: null,
    stdy_imvrp_pid_sae: null,
    stdy_imvrp_pid_sae_comm: null,
    stdy_imvrp_pid_pd: null,
    stdy_imvrp_pid_pd_comm: null,
    stdy_imvrp_pid_sub_concern: null,
    stdy_imvrp_pid_sub_concern_comm: null,
    stdy_imvrp_pid_add: null,
    stdy_imvrp_pid_add_comm: null
  });

  const signatureIntialSte = {
    stdy_imvrp_prepared_by: null,
    stdy_imvrp_prepared_date: null,
    stdy_imvrp_reviewed_by: null,
    stdy_imvrp_reviewed_date: null,
    stdy_imvrp_approval_by: null,
    stdy_imvrp_approved_date: null,
    stdy_imvrp_add_comments: null
  };

  const [signature, setSignature] = useState<any>(signatureIntialSte);

  const [openSendForReviewDialog, setOpenSendForReviewDialog] = useState<boolean>(false);
  const [commentErr, setCommentErr] = useState<boolean>(false);
  const [isChanged, setIsChanged] = useState(false);
  const [openConfirmExit, setOpenConfirmExit] = useState(false);

  /**Function for Signing **/

  const handleSign = async (field: string, dateTime: string) => {
    if (imvReportData) {
      const data = {
        name_of_signature: field,
        name_of_date_field: dateTime
      };

      await updateSignDataFn({
        site_id: selectedSite,
        study_id: studyId,
        data,
        country: selectedCountry,
        application: process.env.REACT_APP_NAME,
        monitoring_visit_id: selectedRowData.id
      });
      getImvReportData();
    } else {
      dispatch(
        setMessage({
          msgDetails: 'No data modified',
          severity: 'success'
        })
      );
    }
  };
  const handleSignReviewedBy = async (field: string, dateTime: string) => {
    const data = {
      name_of_signature: field,
      name_of_date_field: dateTime
    };
    await updateSignDataFn({
      site_id: selectedSite,
      study_id: studyId,
      data,
      country: selectedCountry,
      application: process.env.REACT_APP_NAME,
      monitoring_visit_id: selectedRowData.id
    });
    getImvReportData();
  };
  const handleSignApprovedBy = async (field: string, dateTime: string) => {
    const data = {
      name_of_signature: field,
      name_of_date_field: dateTime
    };
    await updateSignDataFn({
      site_id: selectedSite,
      study_id: studyId,
      data,
      country: selectedCountry,
      application: process.env.REACT_APP_NAME,
      monitoring_visit_id: selectedRowData.id
    });
    getImvReportData();
    setIsSaveEnable(false);
  };

  const getMonitoringVisitList = async (
    studyId: string | null,
    selectedCountry: string | null,
    selectedSite: string | null,
    currentApp: string
  ) => {
    const allMonitoringResponse: any = await getAllMonitoringVisits({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application_section: currentApp,
      data: {}
    });
    if (allMonitoringResponse.data && allMonitoringResponse.data.selected_data.length > 0) {
      const imvCheckedInDate: any = allMonitoringResponse.data.selected_data.filter(
        (visit: any) => visit.visit_type === 'Interim Monitoring Visit' && visit.id === selectedRowData.id
      );
      if (imvCheckedInDate.length && imvCheckedInDate[0].actual_start_date) {
        setCheckedInStartDate(
          moment(`${imvCheckedInDate[0].actual_start_date.replace(' ', 'T')}Z`).format(
            userPreferedDateFormat.toUpperCase()
          )
        );
      } else {
        setCheckedInStartDate(null);
      }
    } else {
      setCheckedInStartDate(null);
    }
  };

  const handleCheck = (e: any, Section?: string) => {
    setIsChanged(true);
    if (Section === 'personnelPresent') {
      if (e.target.name in personnelPresent) {
        setPersonnelPresent({
          ...personnelPresent,
          [e.target.name]: e.target.value
        });
      }
    }
    if (Section === 'recruitmentStatus') {
      if (e.target.name in recruitmentStatus) {
        setRecruitmentStatus({
          ...recruitmentStatus,
          [e.target.name]: e.target.value
        });
      }
    }
    if (Section === 'section1') {
      if (e.target.name in section1) {
        setSection1({
          ...section1,
          [e.target.name]: e.target.value
        });
      }
    }

    if (Section === 'section2') {
      if (e.target.name in section2) {
        setSection2({
          ...section2,
          [e.target.name]: e.target.value
        });
      }
    }

    if (Section === 'section3') {
      if (e.target.name in section3) {
        setSection3({
          ...section3,
          [e.target.name]: e.target.value
        });
      }
    }

    if (Section === 'section4') {
      if (e.target.name in section4) {
        setSection4({
          ...section4,
          [e.target.name]: e.target.value
        });
      }
    }

    if (Section === 'section5') {
      if (e.target.name in section5) {
        setSection5({
          ...section5,
          [e.target.name]: e.target.value
        });
      }
    }

    if (Section === 'section6') {
      if (e.target.name in section6) {
        setSection6({
          ...section6,
          [e.target.name]: e.target.value
        });
      }
    }

    if (Section === 'section7') {
      if (e.target.name in section7) {
        setSection7({
          ...section7,
          [e.target.name]: e.target.value
        });
      }
    }
    if (Section === 'section8') {
      if (e.target.name in section8) {
        setSection8({
          ...section8,
          [e.target.name]: e.target.value
        });
      }
    }
    if (Section === 'section9') {
      if (e.target.name in section9) {
        setSection9({
          ...section9,
          [e.target.name]: e.target.value
        });
      }
    }
    if (Section === 'section10') {
      if (e.target.name in section10) {
        setSection10({
          ...section10,
          [e.target.name]: e.target.value
        });
      }
    }
    if (Section === 'section11') {
      if (e.target.name in section11) {
        setSection11({
          ...section11,
          [e.target.name]: e.target.value
        });
      }
    }
    if (Section === 'signatures') {
      if (e.target.name in signature) {
        setSignature({
          ...signature,
          [e.target.name]: e.target.value
        });
      }
      setCommentErr(false);
    }
    setConfirmExitValue(dispatch, true);
    setIsDataUpdate(true);
    setIsSaveEnable(true);
  };

  const [getImvReportDatafunc, { data: imvReportData, isLoading: imvReportLoading }] = useLazyGetimvReportDataQuery();
  const getImvReportData = () => {
    getImvReportDatafunc({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: process.env.REACT_APP_NAME,
      monitoring_visit_id: selectedRowData.id
    });
  };

  useEffect(() => {
    if (selectedRowData) {
      getImvReportData();
    }
  }, [selectedRowData]);

  const handleToogleAccordion = () => {
    setExpanded(!expanded);
    setExpanded0(false);
    setExpanded1(false);
    setExpanded2(false);
    setExpanded3(false);
    setExpanded4(false);
    setExpanded5(false);
    setExpanded6(false);
    setExpanded7(false);
    setExpanded8(false);
    setExpanded9(false);
    setExpanded10(false);
    setExpanded11(false);
    setExpanded12(false);
  };
  const handleToogleAccordion0 = () => {
    setExpanded0(!expanded0);
    setExpanded(false);
    setExpanded1(false);
    setExpanded2(false);
    setExpanded3(false);
    setExpanded4(false);
    setExpanded5(false);
    setExpanded6(false);
    setExpanded7(false);
    setExpanded8(false);
    setExpanded9(false);
    setExpanded10(false);
    setExpanded11(false);
    setExpanded12(false);
  };
  const handleToogleAccordion1 = () => {
    setExpanded1(!expanded1);
    setExpanded(false);
    setExpanded0(false);
    setExpanded2(false);
    setExpanded3(false);
    setExpanded4(false);
    setExpanded5(false);
    setExpanded6(false);
    setExpanded7(false);
    setExpanded8(false);
    setExpanded9(false);
    setExpanded10(false);
    setExpanded11(false);
    setExpanded12(false);
  };
  const handleToogleAccordion2 = () => {
    setExpanded2(!expanded2);
    setExpanded(false);
    setExpanded0(false);
    setExpanded1(false);
    setExpanded3(false);
    setExpanded4(false);
    setExpanded5(false);
    setExpanded6(false);
    setExpanded7(false);
    setExpanded8(false);
    setExpanded9(false);
    setExpanded10(false);
    setExpanded11(false);
    setExpanded12(false);
  };

  const handleToogleAccordion3 = () => {
    setExpanded3(!expanded3);
    setExpanded(false);
    setExpanded0(false);
    setExpanded1(false);
    setExpanded2(false);
    setExpanded4(false);
    setExpanded5(false);
    setExpanded6(false);
    setExpanded7(false);
    setExpanded8(false);
    setExpanded9(false);
    setExpanded10(false);
    setExpanded11(false);
    setExpanded12(false);
  };
  const handleToogleAccordion4 = () => {
    setExpanded4(!expanded4);
    setExpanded(false);
    setExpanded0(false);
    setExpanded1(false);
    setExpanded2(false);
    setExpanded3(false);
    setExpanded5(false);
    setExpanded6(false);
    setExpanded7(false);
    setExpanded8(false);
    setExpanded9(false);
    setExpanded10(false);
    setExpanded11(false);
    setExpanded12(false);
  };
  const handleToogleAccordion5 = () => {
    setExpanded5(!expanded5);
    setExpanded(false);
    setExpanded0(false);
    setExpanded1(false);
    setExpanded2(false);
    setExpanded3(false);
    setExpanded4(false);
    setExpanded6(false);
    setExpanded7(false);
    setExpanded8(false);
    setExpanded9(false);
    setExpanded10(false);
    setExpanded11(false);
    setExpanded12(false);
  };
  const handleToogleAccordion6 = () => {
    setExpanded6(!expanded6);
    setExpanded(false);
    setExpanded0(false);
    setExpanded1(false);
    setExpanded2(false);
    setExpanded3(false);
    setExpanded4(false);
    setExpanded5(false);
    setExpanded7(false);
    setExpanded8(false);
    setExpanded9(false);
    setExpanded10(false);
    setExpanded11(false);
    setExpanded12(false);
  };
  const handleToogleAccordion7 = () => {
    setExpanded7(!expanded7);
    setExpanded(false);
    setExpanded0(false);
    setExpanded1(false);
    setExpanded2(false);
    setExpanded3(false);
    setExpanded4(false);
    setExpanded5(false);
    setExpanded6(false);
    setExpanded8(false);
    setExpanded9(false);
    setExpanded10(false);
    setExpanded11(false);
    setExpanded12(false);
  };
  const handleToogleAccordion8 = () => {
    setExpanded8(!expanded8);
    setExpanded(false);
    setExpanded0(false);
    setExpanded1(false);
    setExpanded2(false);
    setExpanded3(false);
    setExpanded4(false);
    setExpanded5(false);
    setExpanded6(false);
    setExpanded7(false);
    setExpanded9(false);
    setExpanded10(false);
    setExpanded11(false);
    setExpanded12(false);
  };
  const handleToogleAccordion9 = () => {
    setExpanded9(!expanded9);
    setExpanded(false);
    setExpanded0(false);
    setExpanded1(false);
    setExpanded2(false);
    setExpanded3(false);
    setExpanded4(false);
    setExpanded5(false);
    setExpanded6(false);
    setExpanded7(false);
    setExpanded8(false);
    setExpanded10(false);
    setExpanded11(false);
    setExpanded12(false);
  };
  const handleToogleAccordion10 = () => {
    setExpanded10(!expanded10);
    setExpanded(false);
    setExpanded0(false);
    setExpanded1(false);
    setExpanded2(false);
    setExpanded3(false);
    setExpanded4(false);
    setExpanded5(false);
    setExpanded6(false);
    setExpanded7(false);
    setExpanded8(false);
    setExpanded9(false);
    setExpanded11(false);
    setExpanded12(false);
  };
  const handleToogleAccordion11 = () => {
    setExpanded11(!expanded11);
    setExpanded(false);
    setExpanded0(false);
    setExpanded1(false);
    setExpanded2(false);
    setExpanded3(false);
    setExpanded4(false);
    setExpanded5(false);
    setExpanded6(false);
    setExpanded7(false);
    setExpanded8(false);
    setExpanded9(false);
    setExpanded10(false);
    setExpanded12(false);
  };

  const handleToogleAccordion12 = () => {
    setExpanded12(!expanded12);
    setExpanded(false);
    setExpanded0(false);
    setExpanded1(false);
    setExpanded2(false);
    setExpanded3(false);
    setExpanded4(false);
    setExpanded5(false);
    setExpanded6(false);
    setExpanded7(false);
    setExpanded8(false);
    setExpanded9(false);
    setExpanded(false);
    setExpanded10(false);
    setExpanded11(false);
  };

  const handleOpenSendForReview = () => {
    setOpenSendForReviewDialog(true);
  };

  const handleCloseSendForReview = () => {
    setOpenSendForReviewDialog(false);
  };

  useEffect(() => {
    if (imvReportData) {
      setPersonnelPresent(imvReportData.conduct_personnel_present);
      setRecruitmentStatus(imvReportData.recruitment_status_at_site);
      setSection1(imvReportData.site_adequacy);
      setSection2(imvReportData.ec_irb);
      setSection3(imvReportData.informed_consent);
      setSection4(imvReportData.monitoring_activities);
      setSection5(imvReportData.sae_safety_reporting);
      setSection6(imvReportData.protocol_compliance);
      setSection7(imvReportData.investigational_medicinal_product);
      setSection8(imvReportData.supplies_including_ancillaries);
      setSection9(imvReportData.biological_sampling);
      setSection10(imvReportData.local_lab_only);
      setSection11(imvReportData.discussion_with_pi);
      setSignature(imvReportData.signature);
      setIsupdate(true);
      setIsDataUpdate(false);
      setIsprintEnable(true);
    }
  }, [imvReportData]);

  const postData = async () => {
    if (isDataUpdate) {
      const personnelPresentRes = personnelPresent.map((item: any) => {
        return {
          personnel_id: item.id,
          stdy_imvrp_personnel_name: item.stdy_imvrp_personnel_name,
          stdy_imvrp_personnel_role: item.stdy_imvrp_personnel_role,
          stdy_imvrp_personnel_affiliation: item.stdy_imvrp_personnel_affiliation
        };
      });
      try {
        if (isUpdate) {
          const payload = {
            notify_user: null,
            updated_by: user
          };
          await sendForReviewFunc({
            site_id: selectedSite,
            study_id: studyId,
            data: payload,
            country: selectedCountry,

            application: process.env.REACT_APP_NAME,
            monitoring_visit_id: selectedRowData.id
          });
          setSignature(signatureIntialSte);
          const ureqObj = {
            imv_report: {
              personnel_present: personnelPresentRes,
              recruitment_status_at_site: { ...recruitmentStatus },
              site_adequacy: { ...section1 },
              ec_irb: { ...section2 },
              informed_consent: { ...section3 },
              monitoring_activities: { ...section4 },
              sae_safety_reporting: { ...section5 },
              protocol_compliance: { ...section6 },
              investigational_medicinal_product: { ...section7 },
              supplies_including_ancillaries: { ...section8 },
              biological_sampling: { ...section9 },
              local_lab_only: { ...section10 },
              discussion_with_pi: { ...section11 },
              signature: { ...signatureIntialSte }
            },
            monitoring_visit_id: selectedRowData.id,
            is_submit: false,
            updated_by: user,
            is_published: false
          };
          await updateImvReportDataFn({
            site_id: selectedSite,
            study_id: studyId,
            data: ureqObj,
            country: selectedCountry,

            application: process.env.REACT_APP_NAME
          });
        } else {
          const creqObj = {
            imv_report: {
              personnel_present: personnelPresentRes,
              recruitment_status_at_site: { ...recruitmentStatus },
              site_adequacy: { ...section1 },
              ec_irb: { ...section2 },
              informed_consent: { ...section3 },
              monitoring_activities: { ...section4 },
              sae_safety_reporting: { ...section5 },
              protocol_compliance: { ...section6 },
              investigational_medicinal_product: { ...section7 },
              supplies_including_ancillaries: { ...section8 },
              biological_sampling: { ...section9 },
              local_lab_only: { ...section10 },
              discussion_with_pi: { ...section11 },
              signature: { ...signature }
            },
            monitoring_visit_id: selectedRowData.id,
            is_submit: false,
            created_by: user
          };
          await createImvReportDataFn({
            site_id: selectedSite,
            study_id: studyId,
            data: creqObj,
            country: selectedCountry,
            application: process.env.REACT_APP_NAME
          });
        }
        setConfirmExitValue(dispatch, false);
        getImvReportData();
      } catch (e) {
        dispatchApp(setMessage({ msgDetails: 'Error occurred while saving the data', severity: 'error' }));
      }
    } else {
      dispatch(
        setMessage({
          msgDetails: 'No data modified',
          severity: 'success'
        })
      );
    }
    setIsChanged(false);
  };

  const handleSaveSignature = async () => {
    if (signature?.stdy_imvrp_add_comments) {
      const res = personnelPresent.map((item: any) => {
        return {
          stdy_imvrp_personnel_name: item.stdy_imvrp_personnel_name,
          stdy_imvrp_personnel_role: item.stdy_imvrp_personnel_role,
          stdy_imvrp_personnel_affiliation: item.stdy_imvrp_personnel_affiliation
        };
      });
      const payload = {
        imv_report: {
          personnel_present: res,
          recruitment_status_at_site: { ...recruitmentStatus },
          site_adequacy: { ...section1 },
          ec_irb: { ...section2 },
          informed_consent: { ...section3 },
          monitoring_activities: { ...section4 },
          sae_safety_reporting: { ...section5 },
          protocol_compliance: { ...section6 },
          investigational_medicinal_product: { ...section7 },
          supplies_including_ancillaries: { ...section8 },
          biological_sampling: { ...section9 },
          local_lab_only: { ...section10 },
          discussion_with_pi: { ...section11 },
          signature: { ...signature },
          is_published: false
        },
        monitoring_visit_id: selectedRowData.id,
        is_submit: false,
        updated_by: user
      };

      await updateImvReportDataFn({
        site_id: selectedSite,
        study_id: studyId,
        data: payload,
        country: selectedCountry,

        application: process.env.REACT_APP_NAME
      });
      getImvReportData();
    } else {
      setCommentErr(true);
    }
    setIsChanged(false);
  };

  const handelBack = () => {
    if (isChanged) {
      setOpenConfirmExit(true);
    } else {
      dispatch(setShowIMVReportCMPArr('IMVReportTable'));
    }
  };
  useEffect(() => {
    getMonitoringVisitList(studyId, selectedCountry, selectedSite, selectedAppSection);
    return () => {
      dispatch(setShowIMVReportCMPArr('IMVReportTable'));
    };
  }, []);

  useEffect(() => {
    if (createImvReportSuccess || updateImvReportSuccess || updateSignSuccess) {
      dispatchApp(setMessage({ msgDetails: 'Data Updated', severity: 'success' }));
      setIsprintEnable(true);
    }
  }, [createImvReportSuccess, updateImvReportSuccess, updateSignSuccess]);

  useEffect(() => {
    if (createImvReportLoading || updateSignIsLoading || updateImvReportIsLoading || imvReportLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [createImvReportLoading, updateSignIsLoading, updateImvReportIsLoading, imvReportLoading]);

  useEffect(() => {
    if (createImvReportIsError || updateImvReportIsError) {
      setIsprintEnable(false);
      const err: any = createImvReportError || updateImvReportError;
      if (err?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403 Restricted User permission',
            severity: 'error'
          })
        );
      } else if (err?.status == 404) {
        dispatch(
          setMessage({
            msgDetails: 'No updates',
            severity: 'error'
          })
        );
      }
    }
  }, [createImvReportIsError, updateImvReportIsError]);

  useEffect(() => {
    if (updateSignIsError) {
      const err: any = updateSignError;
      if (err?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403 Restricted User permission',
            severity: 'error'
          })
        );
      } else if (err?.status == 404) {
        const errorMessage = err?.data?.context?.message;
        dispatch(
          setMessage({
            msgDetails: errorMessage ? errorMessage : 'No data modified',
            severity: 'error'
          })
        );
      }
    }
  }, [updateSignIsError]);

  useEffect(() => {
    if (publishImvReportSuccess) {
      dispatchApp(
        setMessage({ msgDetails: 'IMV Report successfully published to ETMF repository', severity: 'success' })
      );
    } else if (publishImvReportError) {
      dispatchApp(setMessage({ msgDetails: 'IMV Report publish is getting Error', severity: 'error' }));
    }
  }, [publishImvReportSuccess, publishImvReportError]);

  const isUpdatePublish = imvReportData?.imv_report_publish_version ? true : false;
  /* publish checklist data */
  const publishData = async () => {
    try {
      dispatch(showLoader());
      await publishToEtmf();
    } catch (e) {
      dispatchApp(setMessage({ msgDetails: 'Error occurred while saving the data', severity: 'error' }));
      dispatch(hideLoader());
    }
    dispatch(hideLoader());
  };
  async function publishToEtmf() {
    let version = '';
    if (isUpdatePublish) {
      version = imvReportData?.imv_report_publish_version + 1;
    } else {
      version = '1';
    }

    await publishImvReportDataFn({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,

      publish_doc_version: version,
      monitoring_visit_id: selectedRowData.id,
      is_published: true,
      update: isUpdatePublish,
      application: process.env.REACT_APP_NAME
    });

    setConfirmExitValue(dispatch, false);
    setIsSaveEnable(false);
    getImvReportData();
  }

  const printImvReportForm = async () => {
    try {
      dispatch(showLoader());
      const options = {
        monitoring_visit_id: imvReportData?.monitoring_visit_id,
        template_name: 'imv_report',
        study_id: studyId,
        site_id: selectedSite,
        pathVariables: {
          country: selectedCountry,
          appName: archLevel === 'sponsor' ? process.env.REACT_APP_NAME : 'TSDA',
          time_zone_id: UI_TIME_ZONE
        }
      };
      let pdfOptions: any = {};
      if (imvReportData?.imv_report_publish_version) {
        pdfOptions = {
          ...options,
          pathVariables: {
            version: imvReportData.imv_report_publish_version.toFixed(1),
            ...options.pathVariables
          }
        };
      } else {
        pdfOptions = options;
      }
      const printViewerApiString = imvReportData?.imv_report_publish_version
        ? 'get_imvChecklist_pdf_file_version'
        : 'get_imvChecklist_pdf_file';
      printPdfWithViewer(printViewerApiString, pdfOptions, 'application/pdf');

      setTimeout(function () {
        dispatch(hideLoader());
      }, 1500);
    } catch (error: any) {
      dispatch(hideLoader());
      dispatch(setMessage({ msgDetails: 'Error while fetching pdf', severity: 'error' }));
    }
  };

  return (
    <>
      <Loader />
      <Box className="mainBackBtnWrap" sx={{ ml: 0.5 }}>
        <Button onClick={handelBack} startIcon={<ArrowBackIcon fontSize="small" />}>
          LIST OF IMV REPORTS
        </Button>
      </Box>
      <div className="pi-accordion" style={{ marginBottom: 0 }}>
        {isLoading && <ProgressBar />}
        <Grid container spacing={2} alignItems="center" className="titleGrid">
          <Grid item xs>
            <Stack direction="row" spacing={4} alignItems="center">
              <Typography variant="h6" component="h6" sx={{ pl: 2 }}>
                {selectedRowData.visit_name}
              </Typography>
            </Stack>
          </Grid>
          <Grid item sx={{ textAlign: 'right', display: 'flex' }}>
            <Stack direction="row" spacing={1}>
              <LoadingButton
                onClick={postData}
                disabled={!checkPermission('update_imvreport') || !isSaveEnable || disable}
                loading={updateImvReportIsLoading || createImvReportLoading}
              >
                SAVE
              </LoadingButton>
              <IconButton disabled={!isPrintEnable} onClick={printImvReportForm}>
                <LocalPrintshopIcon />
              </IconButton>
            </Stack>
          </Grid>
        </Grid>

        <Grid container rowSpacing={1} columnSpacing={{ md: 3 }} sx={{ typography: 'body1', mb: 2, pl: 2 }}>
          <Grid item md={6}>
            <Typography>
              <strong>Protocol Number: </strong>
              <span className="results"> </span>
            </Typography>
          </Grid>
          <Grid item md={6}>
            <Typography>
              <strong>Company Confidential </strong>
              <span className="results"> </span>
            </Typography>
          </Grid>
          <Grid item md={6}>
            <Typography>
              <strong>Investigator Name: </strong>
              <span className="results"> </span>
            </Typography>
          </Grid>
          <Grid item md={6}>
            <Typography>
              <strong>Document No: </strong>
              <span className="results">xxxx </span> <span>Version: </span>
              <span className="results">
                {selectedRowData.major_version != '0.0' ? selectedRowData.major_version : '1.0'}{' '}
              </span>
            </Typography>
          </Grid>

          <Grid item md={6}>
            <Typography>
              <strong>Site Number: </strong>
              <span className="results">{selectedRowData.site_id} </span>
            </Typography>
          </Grid>

          <Grid item md={6}>
            <Typography>
              <strong>Effective Date: </strong>
              <span className="results">MM/DD/YY</span>
            </Typography>
          </Grid>
          <Grid item md={6}>
            <Typography>
              <strong>Investigative Site Address:</strong>
              <span className="results"> </span>
            </Typography>
          </Grid>

          <Grid item md={6}>
            <Typography>
              <strong>Visit Type:</strong>
              <span className="results"> {selectedRowData.visit_type} </span>
            </Typography>
          </Grid>

          <Grid item md={6}>
            <Typography>
              <strong>Satellite Site:</strong>
              <span className="results"> </span>
            </Typography>
          </Grid>

          <Grid item md={6}>
            <Typography>
              <strong>Date of Visit: </strong>
              <span className="results">
                {
                  getPreferredDateTimeInLocal(
                    checkedInStartDate ? checkedInStartDate : selectedRowData.start_date
                  ).split(' ')[0]
                }{' '}
              </span>
            </Typography>
          </Grid>
        </Grid>

        <Accordion expanded={expanded} onChange={handleToogleAccordion}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>Personnel Present During Visit, including CRA</Typography>
          </AccordionSummary>
          <PersonnelPresent
            personnelPresent={personnelPresent}
            setIsChanged={setIsChanged}
            handleCheck={handleCheck}
            setPersonnelPresent={setPersonnelPresent}
            isDisable={isDisable}
            setIsDataUpdate={setIsDataUpdate}
            isSaveEnable={isSaveEnable}
            setIsSaveEnable={setIsSaveEnable}
            disable={disable}
          />
        </Accordion>

        <Accordion expanded={expanded0} onChange={handleToogleAccordion0}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>Recruitment Status at Site</Typography>
          </AccordionSummary>
          <RecruitmentStatus
            recruitmentStatus={recruitmentStatus}
            handleCheck={handleCheck}
            isDisable={isDisable}
            disable={disable}
          />
        </Accordion>

        <Accordion expanded={expanded1} onChange={handleToogleAccordion1}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>Site Adequacy, Site Status, Site Training</Typography>
          </AccordionSummary>
          <Site
            imvChecklistPageData={imvChecklistPageData}
            setImvChecklistPageData={setImvChecklistPageData}
            handleCheck={handleCheck}
            isDisable={isDisable}
            validationObj={section1}
            fileObjects={fileObjects}
            setFileObjects={setFileObjects}
            setSection1={setSection1}
            section1={section1}
            setIsChanged={setIsChanged}
            setIsDataUpdate={setIsDataUpdate}
            disable={disable}
          />
        </Accordion>
        <Accordion expanded={expanded2} onChange={handleToogleAccordion2}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
            <Typography>EC/IRB</Typography>
          </AccordionSummary>
          <ECIRB
            imvChecklistPageData={imvChecklistPageData}
            setImvChecklistPageData={setImvChecklistPageData}
            handleCheck={handleCheck}
            isDisable={isDisable}
            validationObj={section2}
            disable={disable}
          />
        </Accordion>

        <Accordion expanded={expanded3} onChange={handleToogleAccordion3}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>Informed consent</Typography>
          </AccordionSummary>
          <InfomredConsentProcess
            imvChecklistPageData={imvChecklistPageData}
            setImvChecklistPageData={setImvChecklistPageData}
            handleCheck={handleCheck}
            isDisable={isDisable}
            validationObj={section3}
            fileObjects2={fileObjects2}
            setFileObjects2={setFileObjects2}
            setSection3={setSection3}
            section3={section3}
            setIsChanged={setIsChanged}
            setIsDataUpdate={setIsDataUpdate}
            disable={disable}
          />
        </Accordion>
        <Accordion expanded={expanded4} onChange={handleToogleAccordion4}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>Monitoring activities</Typography>
          </AccordionSummary>
          <MonitioringRequirments
            imvChecklistPageData={imvChecklistPageData}
            setImvChecklistPageData={setImvChecklistPageData}
            handleCheck={handleCheck}
            isDisable={isDisable}
            validationObj={section4}
            fileObjects3={fileObjects3}
            setFileObjects3={setFileObjects3}
            setSection4={setSection4}
            setIsChanged={setIsChanged}
            setIsDataUpdate={setIsDataUpdate}
            disable={disable}
          />
        </Accordion>

        <Accordion expanded={expanded6} onChange={handleToogleAccordion6}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>SAE/Safety reporting</Typography>
          </AccordionSummary>
          <SeriousAdverseEvents
            imvChecklistPageData={imvChecklistPageData}
            setImvChecklistPageData={setImvChecklistPageData}
            handleCheck={handleCheck}
            isDisable={isDisable}
            validationObj={section5}
            fileObjects4={fileObjects4}
            setFileObjects4={setFileObjects4}
            setSection5={setSection5}
            setIsChanged={setIsChanged}
            setIsDataUpdate={setIsDataUpdate}
            disable={disable}
          />
        </Accordion>
        <Accordion expanded={expanded5} onChange={handleToogleAccordion5}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>Protocol Compliance</Typography>
          </AccordionSummary>
          <ProtocolDeviations
            imvChecklistPageData={imvChecklistPageData}
            setImvChecklistPageData={setImvChecklistPageData}
            handleCheck={handleCheck}
            isDisable={isDisable}
            validationObj={section6}
            fileObjects5={fileObjects5}
            setFileObjects5={setFileObjects5}
            setSection6={setSection6}
            setIsChanged={setIsChanged}
            setIsDataUpdate={setIsDataUpdate}
            disable={disable}
          />
        </Accordion>
        <Accordion expanded={expanded7} onChange={handleToogleAccordion7}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>Investigational medicinal product</Typography>
          </AccordionSummary>
          <InvestigationalMedicine
            imvChecklistPageData={imvChecklistPageData}
            setImvChecklistPageData={setImvChecklistPageData}
            handleCheck={handleCheck}
            isDisable={isDisable}
            validationObj={section7}
            fileObjects6={fileObjects6}
            setFileObjects6={setFileObjects6}
            setSection7={setSection7}
            setIsChanged={setIsChanged}
            setIsDataUpdate={setIsDataUpdate}
            disable={disable}
          />
        </Accordion>
        <Accordion expanded={expanded8} onChange={handleToogleAccordion8}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>Supplies including ancillaries</Typography>
          </AccordionSummary>
          <Supplies
            imvChecklistPageData={imvChecklistPageData}
            setImvChecklistPageData={setImvChecklistPageData}
            handleCheck={handleCheck}
            isDisable={isDisable}
            validationObj={section8}
            fileObjects={fileObjects}
            setFileObjects={setFileObjects}
            disable={disable}
          />
        </Accordion>
        <Accordion expanded={expanded9} onChange={handleToogleAccordion9}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>Biological sampling</Typography>
          </AccordionSummary>
          <BiologicalSampling
            imvChecklistPageData={imvChecklistPageData}
            setImvChecklistPageData={setImvChecklistPageData}
            handleCheck={handleCheck}
            isDisable={isDisable}
            validationObj={section9}
            fileObjects={fileObjects}
            setFileObjects={setFileObjects}
            disable={disable}
          />
        </Accordion>
        <Accordion expanded={expanded10} onChange={handleToogleAccordion10}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>Local lab only</Typography>
          </AccordionSummary>
          <Lab
            imvChecklistPageData={imvChecklistPageData}
            setImvChecklistPageData={setImvChecklistPageData}
            handleCheck={handleCheck}
            isDisable={isDisable}
            validationObj={section10}
            fileObjects={fileObjects}
            setFileObjects={setFileObjects}
            disable={disable}
          />
        </Accordion>
        <Accordion expanded={expanded11} onChange={handleToogleAccordion11}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>Discussion with PI</Typography>
          </AccordionSummary>
          <Discussion
            imvChecklistPageData={imvChecklistPageData}
            setImvChecklistPageData={setImvChecklistPageData}
            handleCheck={handleCheck}
            isDisable={isDisable}
            validationObj={section11}
            fileObjects={fileObjects}
            setFileObjects={setFileObjects}
            disable={disable}
          />
        </Accordion>

        <Accordion expanded={expanded12} onChange={handleToogleAccordion12}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>Signatures</Typography>
          </AccordionSummary>
          <Signatures
            isDisable={isDisable}
            handleSign={handleSign}
            handleSignReviewedBy={handleSignReviewedBy}
            handleSignApprovedBy={handleSignApprovedBy}
            signature={signature}
            updateSignIsLoading={updateSignIsLoading}
            handleCheck={handleCheck}
            handleSaveSignature={handleSaveSignature}
            imvReportData={imvReportData}
            commentErr={commentErr}
            disable={disable}
          />
        </Accordion>

        <Grid container spacing={2} className="bottom-navigation">
          <Grid item md={12} display="flex" justifyContent="flex-end">
            <Stack spacing={2} direction="row">
              <Button
                onClick={publishData}
                variant="contained"
                disabled={
                  !checkPermission('publish_imvreport') ||
                  imvReportData?.signature?.stdy_imvrp_add_comments == null ||
                  imvReportData?.is_published
                }
                style={{ textTransform: 'none' }}
              >
                PUBLISH TO eTMF
              </Button>
              {imvReportData?.created_by == user && imvReportData?.signature?.stdy_imvrp_approval_by ? (
                <Button onClick={handleOpenSendForReview} variant="contained" disabled>
                  SEND FOR REVIEW
                </Button>
              ) : imvReportData?.notify_user ? (
                <Button variant="contained" disabled>
                  SEND FOR APPROVAL
                </Button>
              ) : (
                <Button
                  onClick={handleOpenSendForReview}
                  variant="contained"
                  disabled={
                    !isDisable ||
                    imvReportData?.signature?.stdy_imvrp_prepared_by == undefined ||
                    imvReportData?.signature?.stdy_imvrp_prepared_by == null
                  }
                >
                  SEND FOR REVIEW
                </Button>
              )}
            </Stack>
          </Grid>
        </Grid>
      </div>
      {openSendForReviewDialog && (
        <IMVReportSendForReview
          openSendForReviewDialog={openSendForReviewDialog}
          handleCloseSendForReview={handleCloseSendForReview}
          monitoring_visit_id={selectedRowData.id}
          getImvReportData={getImvReportData}
        />
      )}
      <PopupComponent
        open={openConfirmExit}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="confirm-modal"
        child
      >
        <DialogTitle id="alert-dialog-title">
          <b>Please Confirm</b>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            All unsaved changes will be lost. Are you sure you want to exit before saving your changes?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenConfirmExit(false);
            }}
            className="grey-btn"
          >
            CLOSE
          </Button>
          <Button
            onClick={() => {
              setOpenConfirmExit(false);
              dispatch(setShowIMVReportCMPArr('IMVReportTable'));
              setIsChanged(false);
            }}
          >
            EXIT
          </Button>
        </DialogActions>
      </PopupComponent>
    </>
  );
};

export default IMVReportPage;
